import {colorVar} from '@app/lui2/Theme/colors';
import styled, {css} from 'styled-components';

interface Props {
  disabled: boolean;
}

const BaseContentLayer = styled.div<Props>`
  --badge-default-size: 1rem;
  ${({disabled}) =>
    disabled &&
    css`
      color: ${colorVar('onSurface')} !important;
      opacity: 0.38;
    `}
`;

export default BaseContentLayer;
